import { FC } from 'react';

import { colors } from '@opendoor/bricks/theme/eero';

interface IReportIconProps {
  color?: string;
}

const DEFAULT_COLOR = colors.brand50;

/** @deprecated */
const ReportIcon: FC<IReportIconProps> = (props: IReportIconProps) => (
  <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 20.5H2.5C1.396 20.5 0.5 19.604 0.5 18.5V2.5C0.5 1.396 1.396 0.5 2.5 0.5H19.5C20.604 0.5 21.5 1.396 21.5 2.5V15.5L17 20.5V20.5Z"
      stroke={props.color || DEFAULT_COLOR}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 20.5V15.5H21.5"
      stroke={props.color || DEFAULT_COLOR}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 5.5H19"
      stroke={props.color || DEFAULT_COLOR}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 10.5H19"
      stroke={props.color || DEFAULT_COLOR}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 15.5H14"
      stroke={props.color || DEFAULT_COLOR}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 18V3"
      stroke={props.color || DEFAULT_COLOR}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ReportIcon;
